"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _Icon = _interopRequireDefault(require("../../Icon"));
var _appendCss = _interopRequireDefault(require("../../utils/appendCss"));
var _ie_css = _interopRequireDefault(require("../InputText/ie_css"));
var _InputText = require("../InputText/InputText.utils");
var _InputText_css = _interopRequireDefault(require("../InputText/InputText_css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * TextArea controlled component
 *
 * @FormGroupCompatible
 * @export
 * @class TextArea
 * @extends {Component}
 */
class TextAreaComp extends _react.Component {
  constructor(props) {
    super(props);
    /**
     * Change event handler for input value.
     *
     * @memberof TextArea
     * @param {object} event
     */
    (0, _defineProperty2.default)(this, "handleChange", event => {
      let value = event.target.value;

      //if there is an icon, defines whether text would overflow beneath
      //the icon or not.
      if ("icon" in this.props) {
        this.inputWidth.innerText = event.target.value;
        if (this.inputWidth.offsetWidth > this.props.innerRef.current ? this.props.innerRef.current.offsetWidth - 15 : 0) {
          this.setState({
            isTextOverflowed: true
          });
        } else {
          this.setState({
            isTextOverflowed: false
          });
        }
      }

      //FormGroup change event handler
      if ("onFormValueChanged" in this.props) {
        this.props.onFormValueChanged(value);
      }

      //custom change event handler
      if ("onChange" in this.props) {
        this.props.onChange(event);
      }
    });
    /**
     * Event handler for when a user unfocuses from textbox.
     * Resets animation that occurs when user focuses.
     *
     * @memberof TextArea
     * @param {object} event
     */
    (0, _defineProperty2.default)(this, "handleBlur", event => {
      this.setState({
        isFocused: false
      });

      //FormGroup change event handler
      if ("onFormValueChanged" in this.props) {
        this.props.onFormValueChanged(this.props.value, true);
      }
      if ("onBlur" in this.props) {
        this.props.onBlur(event);
      }
    });
    /**
     * Focus event handler: When user focuses on textbox, default animation start
     * at center of textbox (for example, if user was tabbing through several textboxes)
     *
     * @memberof TextArea
     *  @param {object} event
     */
    (0, _defineProperty2.default)(this, "handleFocus", event => {
      this.setState({
        isFocused: true
      });
    });
    (0, _appendCss.default)("arc_inpt", [_InputText_css.default, (0, _InputText.isIE)() ? _ie_css.default : ""]);
    this.state = {
      isLoading: true,
      hasUserEverInput: props.value !== "",
      isFocused: false,
      isTextOverflowed: false,
      isMouseDown: false
    };
    this.inputId = this.props.id ? this.props.id : (0, _lodash.uniqueId)("textel_");
    this._isMounted = false;
  }

  /**
   * Adds event listener that specifies in state
   * whether the textbox animation has run already or not.
   * Registers specified DOM Nodes with FormGroup, if one exists.
   *
   * @memberof TextArea
   */
  componentDidMount() {
    this._isMounted = true;
    setTimeout(() => {
      this._isMounted && this.setState({
        isLoading: false
      });
    }, 500);
    const {
      registerDOMNodes
    } = this.props;
    if (registerDOMNodes) {
      registerDOMNodes([this.props.innerRef.current, this.container]);
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
    const {
      unregisterDOMNodes
    } = this.props;
    if (unregisterDOMNodes) {
      unregisterDOMNodes([this.props.innerRef.current, this.container]);
    }
  }
  render() {
    const {
      value,
      placeHolder,
      label,
      name,
      errorMsg,
      type,
      icon,
      width,
      height,
      maxLength,
      onClickIcon,
      isDisabled,
      isInline,
      isRequired,
      requiredLabel,
      additionalProps,
      tabIndex
    } = this.props;
    const isInvalid = this.props.isError && "validate" in this.props;
    const showErrorMsg = this.props.isError && errorMsg;
    const textAreaComponent = /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)({
        "input-text__elem": true,
        "preload": this.state.isLoading,
        "inline": isInline,
        "has-icon": icon,
        "error": this.props.isError,
        "invalid": isInvalid,
        "is-focused": this.state.isFocused
      }, this.props.variant),
      style: {
        width: `${width}`,
        height: `${height}`
      },
      ref: node => this.container = node
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "input-text__labelContainer"
    }, /*#__PURE__*/_react.default.createElement("label", {
      className: (0, _classnames.default)({
        "error": this.props.isError,
        "t-body-small": true,
        "hidden": !Boolean(label) && Boolean(placeHolder)
      }),
      htmlFor: this.inputId
    }, `${Boolean(label) ? label : Boolean(placeHolder) ? placeHolder : ""}${isRequired && label ? ` ${requiredLabel}` : ""}`)), placeHolder && !label && /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)({
        "animated-placeholder": true,
        "error-placeholder": this.props.isError,
        "t-body-large": !this.state.isFocused && value === "",
        "t-body-small": value !== "" || this.state.isFocused,
        "is-focused": this.state.isFocused,
        "is-empty": value === "",
        "has-icon": icon
      })
    }, placeHolder), /*#__PURE__*/_react.default.createElement("div", {
      className: "overflow-container",
      style: {
        width: `${width}`,
        height: `${height}`
      }
    }, this.props.children ? this.props.children : /*#__PURE__*/_react.default.createElement("textarea", (0, _extends2.default)({
      tabIndex: tabIndex,
      type: type,
      name: name,
      id: this.inputId,
      ref: this.props.innerRef,
      placeholder: label && placeHolder,
      value: value,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      className: (0, _classnames.default)({
        "t-body-large": true,
        "invalid": isInvalid,
        "error": this.props.isError,
        "has-icon": icon,
        "text-overflowed": this.state.isTextOverflowed
      }),
      disabled: isDisabled,
      required: isRequired,
      maxLength: maxLength,
      style: {
        width: `${width}`,
        height: `${height}`
      }
    }, additionalProps)), " ", icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: icon,
      className: "input_text__icon",
      onClick: onClickIcon,
      size: "md",
      type: onClickIcon ? "button" : "icon"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "input-width",
      ref: node => this.inputWidth = node
    }), " ", /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)({
        "error": true,
        "t-label-small": true,
        "textarea": true,
        "has-error": showErrorMsg
      }),
      role: "alert",
      ref: node => this.errorText = node
    }, showErrorMsg ? errorMsg : "")));
    if ((0, _InputText.isIE)()) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)({
          "ie-wrapper_input-text__elem": true,
          "inline": isInline
        }),
        style: {
          width: `${width}`
        }
      }, textAreaComponent);
    } else {
      return textAreaComponent;
    }
  }
}
const TextArea = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    type = "text",
    value = "",
    label = "",
    isDisabled = false,
    isInline = false,
    isRequired = false,
    requiredLabel = "(required)",
    height = "150px",
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(TextAreaComp, (0, _extends2.default)({
    innerRef: ref || /*#__PURE__*/_react.default.createRef(),
    type,
    value,
    label,
    isDisabled,
    isInline,
    isRequired,
    requiredLabel,
    height
  }, rest));
});
TextArea.propTypes = {
  /** HTML input element type */
  "type": _propTypes.default.string,
  /** Text value of element */
  "value": _propTypes.default.string,
  /** Placeholder value */
  "placeHolder": _propTypes.default.string,
  /** Text of label that sits above textbox */
  "label": _propTypes.default.string,
  /** Text of label for required fields */
  "requiredLabel": _propTypes.default.string,
  /** HTML name attribute */
  "name": _propTypes.default.string,
  /** HTML id attribute */
  "id": _propTypes.default.string,
  /** Name of icon in material-icons-font library */
  "icon": _propTypes.default.string,
  /** Overrides default width of 100% of element */
  "width": _propTypes.default.string,
  /** Overrides default height of 150px of element */
  "height": _propTypes.default.string,
  /** Specifies max number of chars in textbox */
  "maxLength": _propTypes.default.number,
  /** Error message text that appears below textbox on validation fail */
  "errorMsg": _propTypes.default.string,
  /** Custom change event handler */
  "onChange": _propTypes.default.func,
  /** Custom blur event handler */
  "onBlur": _propTypes.default.func,
  /** Specifies whether textbox is disabled */
  "isDisabled": _propTypes.default.bool,
  /** Specifies whether textbox should have display:inline-block  */
  "isInline": _propTypes.default.bool,
  /** Specifies whether value is required or not */
  "isRequired": _propTypes.default.bool,
  /** Allows for custom css classes */
  "variant": _propTypes.default.string,
  /** Allows for additional key:value pairs to apply to the input HTML element */
  "additionalProps": _propTypes.default.object,
  /** Allows for additional input validation behaviors. Function: any validation logic that returns true/false. */
  "validate": _propTypes.default.oneOfType([_propTypes.default.func]),
  /** NOTE: prop name is "ref". a React REF object reference that is applied to the textarea element. */
  "React REF (ref)": _propTypes.default.object
};
var _default = exports.default = TextArea;